<template>
     <Table
        :data="tableData"
        :stripe="true"
        align="top"
        class="table-striped bordered mt-15"
        max-height="250px"
        aria-describedby="cartonTableData"
        >
        {{tableData}}
        <TableColumn label="Carton Type" width="150">
        <template slot-scope="scope">
            <span class="d-block">{{scope.row.carton_sn}}</span>
            <span class="text-xs">{{scope.row.description}}</span>
        </template>
        </TableColumn>
        <TableColumn label="DIM (DM)" width="100">
        <template slot-scope="scope">
            <span>{{scope.row.dimension}} </span>
        </template>
        </TableColumn>
        <TableColumn label="Gross WT" width="100">
        <template slot-scope="scope">
            <span>{{scope.row.net_weight}} kg</span>
        </template>
        </TableColumn>
        <TableColumn label="Pinchems code" width="120">
        <template slot-scope="scope">
            <span>-</span>
        </template>
        </TableColumn>
        <TableColumn label="Pack Qty" >
        <template slot-scope="scope">
            <span>{{scope.row.total_quantity}}</span>
        </template>
        </TableColumn>
    </Table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>
